(function () {
    var issueItem = {
        vPort: 'screen-sm',
        isMobile: false,

        init: function () {
            // issueItem.controls();
            issueItem.truncate();
        },
        truncate: function () {
            $('.issue-item__authors, .loa').not("[data-truncate='none']").truncate({
                // @TODO consider just loa
                lines: 1,
                type: 'list',
                seeMoreLink: true,
                seeLessLink: true,
                seeMoreText: 'SHOW ALL',
                seeLessText: 'SHOW FEWER',
                addClass: 'js--truncated',
                seeMoreIcon: null,
                seeLessIcon: null,
                seeMoreIconMobile: null,
            });

            $('.issue-item__abstract').each((i, o) => {
                const $o = $(o);
                const count = $o.parents('.issue-item--illustrated').length ? 8 : 2;
                // const count = 2;
                $o.children().eq(0).truncate({
                    lines: count,
                    type: 'text',
                    seeMoreLink: true,
                    seeLessLink: true,
                    seeMoreText: 'MORE',
                    seeLessText: 'LESS',
                    addClass: 'js--truncated',
                    seeMoreIcon: null,
                    seeLessIcon: null,
                    seeMoreIconMobile: null,
                });
            });
        },
    };
    UX.issueItem = issueItem;
})();
